import {Component, EventEmitter, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';

import {ClientInterviewService} from '@core/ecv-http-services/services/client-interview.service';
import {DictService} from '@core/ecv-http-services/services/dict.service';
import {JobOrderService} from '@core/ecv-http-services/services/job-order.service';
import {DialogService} from '../../../dialog/dialog.service';
import {DictModel} from '../../../dictionary/dict.model';
import {CustomValidators} from '@core/validator/custom-validators';
import {ValidatorService} from '@core/validator/validator.service';
import {AlertService} from '@widgets/alert/alert.service';
import {BaseFillDataFormComponent} from '@widgets/form-section/base-fill-data-form-component';
import {SalaryModel} from '../salary.model';
import {ClientInterviewQuestionnaireCompetenceRateModel} from './client-interview-questionnaire-competence-rate.model';
import {ClientInterviewQuestionnaireModel} from './client-interview-questionnaire.model';
import {EcvLanguageService} from '@core/ecv-language.service';
import {LabelListComponent} from '@widgets/form-section/label-list/label-list.component';
import {DictEnum} from '../../../enums/dict.enum';
import {NgRedux} from 'ng2-redux';
import {IAppState} from '../../../store';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {SEARCHED_REF_NUMBER} from '../../../actions';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {ClientInterviewStatus} from '../../../enums/client-interview-status.enum';
import {JoinedInterviewModel} from '../joined-interview.model';
import {JoinedInterviewsService} from '@core/ecv-http-services/services/joined-interviews.service';

@Component({
  selector: 'app-client-interview-questionnaire',
  templateUrl: './client-interview-questionnaire.component.html',
})
export class ClientInterviewQuestionnaireComponent extends BaseFillDataFormComponent implements OnInit {

  private static JobOrderRequiredSkillDefaultGrade = 0;

  @ViewChild('skillSelector') skillSelector: LabelListComponent;

  DictEnum = DictEnum;
  clientQuestionnaireDataForm: FormGroup;
  clientHistoryQuestionnaireDataForm: FormGroup;
  clientQuestionnaireModel: ClientInterviewQuestionnaireModel;
  clientQuestionnaires: ClientInterviewQuestionnaireModel[];
  allInterviews: JoinedInterviewModel[];
  refNumber: string;
  showHistory = false;
  competencesDict: DictModel[] = [];
  currentCompetenceRate: ClientInterviewQuestionnaireCompetenceRateModel;
  competences: number[] = [];
  Array = Array;
  salaryModel: SalaryModel;
  showEmptyCompetenceRateError = false;
  showNoCompetenceRatesError = false;
  showEmptyGeneralCandidateRateError = false;
  showEmptySoftSkillsRateError = false;
  pendingDict: number[] = [];
  private newDictPopupOnCloseEventEmitter = new EventEmitter();
  candidateStatusTypes: ClientInterviewStatus[];
  showRefusalTextArea = false;

  constructor(private clientQuestionnaireService: ClientInterviewService,
              private dictService: DictService,
              private dialogService: DialogService,
              private validatorService: ValidatorService,
              private translateService: TranslateService,
              private alertService: AlertService,
              private langService: EcvLanguageService,
              private jobOrderService: JobOrderService,
              private route: ActivatedRoute,
              private location: Location,
              private ngRedux: NgRedux<IAppState>,
              private spinnerService: Ng4LoadingSpinnerService,
              private joinedInterviewsService: JoinedInterviewsService) {
    super();
    this.showHistory = false;
    this.clientQuestionnaireModel = new ClientInterviewQuestionnaireModel();
    this.salaryModel = new SalaryModel();
    this.salaryModel.salaryType = 0;
    this.salaryModel.salaryMode = 1;
    this.currentCompetenceRate = new ClientInterviewQuestionnaireCompetenceRateModel();
  }

  ngOnInit() {
    this.createForm();
    this.createHistoryForm();
    this.initializeStatusTypes();
    this.newDictPopupOnCloseEventEmitter.subscribe(event => {
      this.skillSelector.focus();
    });
    this.prefillRefNumber();
  }

  onSave() {
    this.showNoCompetenceRatesError = this.clientQuestionnaireModel.competenceRates.length === 0;
    this.showEmptyGeneralCandidateRateError = !this.clientQuestionnaireModel.generalCandidateRate;
    this.showEmptySoftSkillsRateError = !this.clientQuestionnaireModel.softSkillsRate;
    this.clientQuestionnaireModel.referenceNumber = this.clientQuestionnaireModel.referenceNumber ?
      this.clientQuestionnaireModel.referenceNumber.trim() : null;
    this.clientQuestionnaireModel.jobOrderNumber = this.clientQuestionnaireModel.jobOrderNumber ?
      this.clientQuestionnaireModel.jobOrderNumber.trim() : null;
    this.clientQuestionnaireModel.jobOrderDescription = this.clientQuestionnaireModel.jobOrderDescription ?
      this.clientQuestionnaireModel.jobOrderDescription.trim() : null;
    this.clientQuestionnaireModel.comments = this.clientQuestionnaireModel.comments ?
      this.clientQuestionnaireModel.comments.trim() : null;
    this.clientQuestionnaireModel.refusalReason = this.clientQuestionnaireModel.refusalReason ?
      this.clientQuestionnaireModel.refusalReason.trim() : null;
    this.validatorService.validate(this.clientQuestionnaireDataForm);
    if (!this.validatorService.isValid(this.clientQuestionnaireDataForm) || this.showNoCompetenceRatesError
      || this.showEmptyGeneralCandidateRateError || this.showEmptySoftSkillsRateError) {
      this.showSaveAlert(false);
      return;
    }

    if (this.salaryModel.salary) {
      this.clientQuestionnaireModel.offeredSalary = parseFloat(this.salaryModel.salary.toString()
        .replace(',', '.'));
      this.clientQuestionnaireModel.offeredSalaryType = this.salaryModel.salaryType;
      this.clientQuestionnaireModel.offeredSalaryMode = this.salaryModel.salaryMode;
    }
    this.clientQuestionnaireService.createClientQuestionnaireData(this.clientQuestionnaireModel).subscribe(
      response => {
        this.ngRedux.dispatch({type: SEARCHED_REF_NUMBER, value: this.clientQuestionnaireModel.referenceNumber});
        if (this.refNumber === this.clientQuestionnaireModel.referenceNumber && this.allInterviews) {
          let interview = response as JoinedInterviewModel;
          interview.interviewType = 'CLIENT_INTERVIEW';
          this.allInterviews.unshift(interview);
        } else {
          this.refNumber = this.clientQuestionnaireModel.referenceNumber;
          this.getAllQuestionnaires();
        }
        this.clearAll();
        this.createForm();
        this.showSaveAlert(true);
      });
  }

  private showSaveAlert(valid: boolean) {
    if (valid) {
      this.translateService.get('ALERT.CLIENT_INTERVIEW_SAVED', {}).subscribe((res: string) => {
        this.alertService.success(res);
      });
    } else {
      this.translateService.get('ALERT.FIX_ERRORS', {}).subscribe((res: string) => {
        this.alertService.error(res);
      });
    }
  }

  onChangeHistoryVisibility() {
    this.showHistory = !this.showHistory;
  }

  searchForExpertsQuestionnaires() {
    this.validatorService.validate(this.clientHistoryQuestionnaireDataForm);
    if (!this.validatorService.isValid(this.clientHistoryQuestionnaireDataForm)) {
      return;
    }
    this.getAllQuestionnaires();
  }

  addCompetence() {
    this.validatorService.validateControl(<FormControl>this.clientQuestionnaireDataForm.get('competence-id'));
    if (!this.clientQuestionnaireDataForm.get('competence-id').valid) {
      return;
    }
    if (!this.currentCompetenceRate.competenceDictId) {
      this.showEmptyCompetenceRateError = true;
      return;
    }
    if (this.currentCompetenceRate.competenceRate === undefined) {
      this.currentCompetenceRate.competenceRate = ClientInterviewQuestionnaireComponent.JobOrderRequiredSkillDefaultGrade;
    }
    if (!this.clientQuestionnaireModel.competenceRates
      .find(cr => cr.competenceDictId === this.currentCompetenceRate.competenceDictId)) {
      this.clientQuestionnaireModel.competenceRates.unshift(this.currentCompetenceRate);
      this.showEmptyCompetenceRateError = false;
      this.showNoCompetenceRatesError = false;
      this.clearCurrentCompetenceRate();
    }
  }

  removeCompetence(index: number) {
    this.clientQuestionnaireModel.competenceRates.splice(index, 1);
  }

  getCompetenceName(id: number): string {
    if (!id) {
      return '';
    }
    const foundCompetences = this.competencesDict.filter(x => x.id === id);
    if (!foundCompetences || foundCompetences.length === 0) {
      if (this.pendingDict.find(x => x === id)) {
        return '';
      }
      this.pendingDict.push(id);
      this.dictService.getDictionary(id).subscribe(response => {
        if (!this.competencesDict.find(x => x.id === id)) {
          this.competencesDict.push(response);
        }
      });
      return '';
    }
    return this.langService.pickFromDictionary(foundCompetences[0]);
  }

  openModal(title: string, dictType: number, control: AbstractControl, maxLength: number) {
    this.dialogService.open(title, dictType, control, maxLength, this.currentCompetenceRate, 'competenceDictId', this.newDictPopupOnCloseEventEmitter);
    this.newDictPopupOnCloseEventEmitter.subscribe((element) => {
      this.clientQuestionnaireDataForm.controls['competence-id'].setValue(element.id);
    });
  }

  onLoadJobOrderSkillsButtonPressed() {
    this.clientQuestionnaireModel.competenceRates = [];
    if (!this.clientQuestionnaireDataForm.get('jobOrderNumber').valid) {
      return;
    }
    this.spinnerService.show();
    this.jobOrderService.getJobOrderSkills(this.clientQuestionnaireModel.jobOrderNumber).subscribe(
      response => {
        const res: DictModel[] = response;
        for (let i = 0; i < res.length; i++) {
          this.addCompetenceRate(res[i], ClientInterviewQuestionnaireComponent.JobOrderRequiredSkillDefaultGrade);
        }
        this.showNoCompetenceRatesError = false;
        this.showEmptyCompetenceRateError = false;
        this.clearCurrentCompetenceRate();
        this.spinnerService.hide();
      }, requestError => {
        this.spinnerService.hide();
      }
    );
  }

  private addCompetenceRate(dict: DictModel, grade: number) {
    // check if already exists
    for (let i = 0; i < this.clientQuestionnaireModel.competenceRates.length; i++) {
      if (this.clientQuestionnaireModel.competenceRates[i].competenceDictId === dict.id) {
        return;
      }
    }
    const rate = new ClientInterviewQuestionnaireCompetenceRateModel();
    rate.competenceRate = grade;
    rate.competenceDictId = dict.id;
    this.clientQuestionnaireModel.competenceRates.unshift(rate);
    this.competencesDict.unshift(dict);
  }

  private createForm() {
    this.clientQuestionnaireDataForm = new FormGroup({
      referenceNumber: new FormControl('', [CustomValidators.notEmpty, CustomValidators.validateReferenceNumber()]),
      jobOrderNumber: new FormControl('', [CustomValidators.notEmpty, CustomValidators.validateJobOrderNumber]),
      offeredSalary: new FormControl('', [Validators.max(1000000), Validators.min(0), CustomValidators.validateDecimal]),
      competence: new FormControl(''),
      'competence-id': new FormControl(true, CustomValidators.validateCorrectDict),
      comments: new FormControl(''),
      softSkillsRate: new FormControl(''),
      generalCandidateRate: new FormControl(''),
      competenceRate: new FormControl(''),
      'candidateStatus': new FormControl('', CustomValidators.notEmpty),
      'refusalReason': new FormControl('')
    });
  }

  private createHistoryForm() {
    this.clientHistoryQuestionnaireDataForm = new FormGroup({
      refNumberSearch: new FormControl('', [Validators.required, CustomValidators.validateReferenceNumber()])
    });
  }

  private clearAll() {
    this.clientQuestionnaireModel = new ClientInterviewQuestionnaireModel();
    this.salaryModel = new SalaryModel();
    this.salaryModel.salaryType = 0;
    this.salaryModel.salaryMode = 1;
    this.showEmptyGeneralCandidateRateError = false;
    this.showEmptySoftSkillsRateError = false;
    this.clearCurrentCompetenceRate();
  }

  private clearCurrentCompetenceRate() {
    this.currentCompetenceRate = new ClientInterviewQuestionnaireCompetenceRateModel();
  }

  private prefillRefNumber() {
    this.route.params.subscribe(params => {
      const refNumberFromUrl = params['refNumber'];
      if (refNumberFromUrl !== undefined) {
        this.refNumber = refNumberFromUrl;
        this.clientQuestionnaireModel.referenceNumber = refNumberFromUrl;
        this.getAllQuestionnaires();
      } else {
        const lastSearchedRefNumber = this.ngRedux.getState().searchedRefNumber;
        if (lastSearchedRefNumber !== undefined) {
          this.clientQuestionnaireModel.referenceNumber = lastSearchedRefNumber;
          this.refNumber = lastSearchedRefNumber;
          this.location.go('/client-interview/' + lastSearchedRefNumber);
          this.getAllQuestionnaires();
        }
      }
    });
  }

  private getAllQuestionnaires() {
    this.joinedInterviewsService.getAllInterviews(this.refNumber).subscribe(response => {
      this.allInterviews = response;
      this.showHistory = true;
      this.ngRedux.dispatch({type: SEARCHED_REF_NUMBER, value: this.refNumber});
    }, () => {
      this.showHistory = false;
      this.allInterviews = undefined;
      this.ngRedux.dispatch({type: SEARCHED_REF_NUMBER, value: undefined});
    });
  }

  private initializeStatusTypes() {
    this.candidateStatusTypes = [];
    for (const s in ClientInterviewStatus) {
      if (typeof ClientInterviewStatus[s] === 'number') {
        this.candidateStatusTypes.push(ClientInterviewStatus[ClientInterviewStatus[s]]);
      }
    }
  }

  onRefusedSelected(statusType: any) {
    if (+statusType === ClientInterviewStatus.REJECTED_AFTER_CI) {
      this.showRefusalTextArea = true;
      this.clientQuestionnaireDataForm.get('refusalReason').setValidators([CustomValidators.notEmpty]);
    } else {
      this.showRefusalTextArea = false;
      this.clientQuestionnaireDataForm.get('refusalReason').clearValidators();
    }
    this.clientQuestionnaireDataForm.get('refusalReason').updateValueAndValidity();
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/interviews/questionnaires/client-interview-questionnaire/client-interview-questionnaire.component.ts